"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addOnsSortFn = exports.addOnsFilterFn = void 0;
var regions_unavailable_1 = require("@launchedla/hb-shared/dist/regions-unavailable");
var classnames_1 = __importDefault(require("classnames"));
var currency_js_1 = __importDefault(require("currency.js"));
var uniq_1 = __importDefault(require("lodash/uniq"));
var React = __importStar(require("react"));
var react_query_1 = require("react-query");
var fetch_user_geolocation_1 = require("../../../utils/fetch-user-geolocation");
var format_price_1 = __importDefault(require("../../../utils/format-price"));
var replace_section_variables_1 = __importDefault(require("../../../utils/replace-section-variables"));
var utils_1 = require("../../account-v3/utils");
var calculations_1 = require("../../bundler-v2/utils/calculations");
var localization_1 = require("../../checkout/localization");
var progress_to_shipping_threshold_bar_1 = __importDefault(require("../../shared-components/progress-to-shipping-threshold-bar"));
var add_on_filters_1 = require("../add-on-filters");
var app_1 = require("../app");
var nav_1 = __importDefault(require("../components/nav"));
var page_1 = __importDefault(require("../components/page"));
var variant_details_modal_1 = __importDefault(require("../components/variant-details-modal"));
var variant_quantity_picker_1 = __importDefault(require("../components/variant-quantity-picker"));
var is_variant_available_1 = __importDefault(require("../is-variant-available"));
var useMemo = React.useMemo, useContext = React.useContext, useEffect = React.useEffect, useState = React.useState;
/** @param userCountryCode Uppercase country code that we believe the user is in. e.g. "US" or "CA" */
var isProductAvailableInRegion = function (productTags, userCountryCode) {
    var e_1, _a;
    var unavailableRegions = (0, regions_unavailable_1.getUnavailableRegions)(productTags);
    try {
        for (var unavailableRegions_1 = __values(unavailableRegions), unavailableRegions_1_1 = unavailableRegions_1.next(); !unavailableRegions_1_1.done; unavailableRegions_1_1 = unavailableRegions_1.next()) {
            var region = unavailableRegions_1_1.value;
            if (userCountryCode === region.countryCode && !region.provinceCode)
                return false;
            // can add a check for an unavailable provinceCode here when needed
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (unavailableRegions_1_1 && !unavailableRegions_1_1.done && (_a = unavailableRegions_1.return)) _a.call(unavailableRegions_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return true;
};
// this reusable function will filter items that should not be displayed
var addOnsFilterFn = function (_a) {
    var shouldHideLowStockItems = _a.shouldHideLowStockItems, userCountryCode = _a.userCountryCode;
    return function (_a) {
        var _b = __read(_a, 2), product = _b[0], variant = _b[1];
        if (shouldHideLowStockItems && (0, utils_1.isVariantLowStock)(variant))
            return false;
        if (userCountryCode && !isProductAvailableInRegion(product.tags.split(', '), userCountryCode))
            return false;
        return (0, is_variant_available_1.default)(variant);
    };
};
exports.addOnsFilterFn = addOnsFilterFn;
// this reusable function helps sort both addOns and discountAddOns
var addOnsSortFn = function (_a) {
    var selIds = _a.selIds;
    return function (_a, _b) {
        var _c = __read(_a, 2), ap = _c[0], a = _c[1];
        var _d = __read(_b, 2), bp = _d[0], b = _d[1];
        if (selIds.includes(a.id))
            return -1; // if we have already selected a, move it up
        if (selIds.includes(b.id))
            return 1; // if we have already selected b, move it up
        if (ap.tags.includes(app_1.sortFirstTag))
            return -1; // if a's product is tagged to show up first, move it up
        if (bp.tags.includes(app_1.sortFirstTag))
            return 1; // if b's product is tagged to show up first, move it up
        if ((0, utils_1.isVariantLowStock)(a))
            return 1; // if a is low stock, move it down
        if ((0, utils_1.isVariantLowStock)(b))
            return -1; // if b is low stock, move it down
        // else move nothing
        return 0;
    };
};
exports.addOnsSortFn = addOnsSortFn;
var SelectDiscountAddOns = function (_a) {
    var _b, _c;
    var discountAddOns = _a.discountAddOns, numDiscountAddOns = _a.numDiscountAddOns, settings = _a.settings;
    if (!discountAddOns)
        return null;
    var context = useContext(app_1.AppContext);
    if (!context)
        return null;
    var selChoices = context.selChoices, selDiscountAddOns = context.selDiscountAddOns, discountAddOnsPerLimit = context.discountAddOnsPerLimit, shouldHideLowStockItems = context.shouldHideLowStockItems, handleIncreaseDiscountAddOnClick = context.handleIncreaseDiscountAddOnClick, handleDecreaseDiscountAddOnClick = context.handleDecreaseDiscountAddOnClick, isTestingExpandedMobileLayout = context.isTestingExpandedMobileLayout, handleExpandedMobileLayoutSetup = context.handleExpandedMobileLayoutSetup, selMainVariant = context.selMainVariant, existingBundle = context.existingBundle;
    var _d = __read(useState(null), 2), openModalProductVariant = _d[0], setOpenModalProductVariant = _d[1];
    // Toggle-able state to trigger update of memoized sorted discount add-ons when "Add-Ons Selected" link is clicked
    var _e = __read(useState(false), 2), sortDiscountAddOns = _e[0], setSortDiscountAddOns = _e[1];
    var handleOpenModalClick = function (_a) {
        var product = _a.product, variant = _a.variant;
        return function () {
            setOpenModalProductVariant([product, variant]);
        };
    };
    var handleCloseModalClick = function () { return setOpenModalProductVariant(null); };
    useEffect(function () {
        var _a;
        if (isTestingExpandedMobileLayout) {
            handleExpandedMobileLayoutSetup();
        }
        var selectedPatterns = selChoices.map(function (c) { return c.option2; });
        (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({ event: 'diaperBundle__discountAddOns', selectedPatterns: (0, uniq_1.default)(selectedPatterns) });
    }, []);
    // Determine the user's country, preferring to check the existing bundle's address if present, and falling back to checking the customer's IP address
    var existingBundleCountry = (_b = existingBundle === null || existingBundle === void 0 ? void 0 : existingBundle.address) === null || _b === void 0 ? void 0 : _b.country;
    var userGeolocationQuery = (0, react_query_1.useQuery)([fetch_user_geolocation_1.getOrFetchAndUpdateCountryCodeByIpCookieUseQueryKey], fetch_user_geolocation_1.getOrFetchAndUpdateCountryCodeByIpCookie, { enabled: !existingBundleCountry });
    var inStockDiscountAddOns = useMemo(function () {
        // Check the existing bundle's address if present
        if (existingBundleCountry) {
            if ((0, localization_1.isCanadianAddressCountry)(existingBundleCountry)) {
                return discountAddOns.filter((0, exports.addOnsFilterFn)({ shouldHideLowStockItems: shouldHideLowStockItems, userCountryCode: 'CA' }));
            }
            // If the bundle isn't shipping to Canada, assume that it's shipping to the US
            return discountAddOns.filter((0, exports.addOnsFilterFn)({ shouldHideLowStockItems: shouldHideLowStockItems, userCountryCode: 'US' }));
        }
        // Fall back to checking the customer's IP address, displaying no products until we know it
        if (!userGeolocationQuery.isSuccess)
            return [];
        return discountAddOns.filter((0, exports.addOnsFilterFn)({ shouldHideLowStockItems: shouldHideLowStockItems, userCountryCode: userGeolocationQuery.data.countryCode }));
    }, [userGeolocationQuery.isSuccess, (_c = userGeolocationQuery.data) === null || _c === void 0 ? void 0 : _c.countryCode, discountAddOns, existingBundleCountry, shouldHideLowStockItems]);
    var _f = (0, add_on_filters_1.initFilters)(inStockDiscountAddOns), filteredAddOns = _f.filteredAddOns, renderFilters = _f.renderFilters, activeFilters = _f.activeFilters, resetFilters = _f.resetFilters;
    var sortedDiscountAddOns = useMemo(function () {
        var selDiscountAddOnsIds = selDiscountAddOns.map(function (v) { return v.id; });
        return filteredAddOns.sort((0, exports.addOnsSortFn)({ selIds: selDiscountAddOnsIds }));
    }, [activeFilters, sortDiscountAddOns, filteredAddOns]);
    var scrollToTop = function () {
        var el = document.getElementById(app_1.overflowDivId);
        if (el) {
            el.scrollTop = 0;
        }
    };
    var bundleSubtotal = useMemo(function () {
        var mainVariant = selMainVariant ? { price: (0, currency_js_1.default)(selMainVariant.price).divide(100).value } : { price: 0 };
        var groupedSelDiscountAddOns = (function () {
            var e_2, _a;
            var addOns = {};
            try {
                for (var selDiscountAddOns_1 = __values(selDiscountAddOns), selDiscountAddOns_1_1 = selDiscountAddOns_1.next(); !selDiscountAddOns_1_1.done; selDiscountAddOns_1_1 = selDiscountAddOns_1.next()) {
                    var addOn = selDiscountAddOns_1_1.value;
                    if (!addOns[addOn.id]) {
                        addOns[addOn.id] = { variant: addOn, quantity: 0 };
                    }
                    addOns[addOn.id].quantity++;
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (selDiscountAddOns_1_1 && !selDiscountAddOns_1_1.done && (_a = selDiscountAddOns_1.return)) _a.call(selDiscountAddOns_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
            return Object.values(addOns);
        })();
        var groupedSelChoices = (function () {
            var e_3, _a;
            var choices = {};
            try {
                for (var selChoices_1 = __values(selChoices), selChoices_1_1 = selChoices_1.next(); !selChoices_1_1.done; selChoices_1_1 = selChoices_1.next()) {
                    var choice = selChoices_1_1.value;
                    if (!choices[choice.id]) {
                        choices[choice.id] = { variant: choice, quantity: 0 };
                    }
                    choices[choice.id].quantity++;
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (selChoices_1_1 && !selChoices_1_1.done && (_a = selChoices_1.return)) _a.call(selChoices_1);
                }
                finally { if (e_3) throw e_3.error; }
            }
            return Object.values(choices);
        })();
        return selMainVariant ? (0, calculations_1.calculateBundleSubtotal)(mainVariant, groupedSelDiscountAddOns, groupedSelChoices) : 0;
    }, [selMainVariant, selDiscountAddOns, selChoices]);
    var freeShippingProgressBarProps = {
        currentValueDollars: bundleSubtotal,
        phases: [{ achievedText: 'FREE shipping', notYetText: 'FREE shipping', color: '#a05eb5', outOfDollars: 75, shippingPrice: 4.99 }],
        tooltipText: 'Excludes Alaska, Hawaii, & Canada',
    };
    var centerContent = (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'large-price lh1 font-bold' },
            selDiscountAddOns.length,
            React.createElement("span", { className: 'font-normal h4 padding-horizontal-2' }, "of"),
            discountAddOnsPerLimit),
        React.createElement("div", { className: 'text-nobel margin-top-1' },
            React.createElement("small", null,
                React.createElement("div", { className: (0, classnames_1.default)('selected-discount-add-ons-active', selDiscountAddOns.length > 0 && 'active'), onClick: function () {
                        // don't do anything if no add-ons are selected
                        if (selDiscountAddOns.length === 0) {
                            return;
                        }
                        // reset filter to go to 'All'
                        resetFilters();
                        // trigger sort for discount addOns
                        setSortDiscountAddOns(!sortDiscountAddOns);
                        // auto scroll to the top of the products div
                        scrollToTop();
                    } }, settings.navCenterTitle)))));
    return (React.createElement(page_1.default, { renderNav: React.createElement(nav_1.default, { canGoNext: true, centerContent: centerContent }) },
        React.createElement("div", { className: 'padding-6 medium-padding-10 large-padding-horizontal-14 large-padding-vertical-8' },
            React.createElement("h1", { className: 'h3' }, settings.header),
            React.createElement("div", { className: 'margin-bottom-4 font-lighter', dangerouslySetInnerHTML: { __html: (0, replace_section_variables_1.default)(settings.subheader, { numDiscountAddOns: "".concat(numDiscountAddOns) }) } }),
            settings.enableProgressToFreeShippingBar && (React.createElement("div", { className: 'bundler-selected-discount-add-ons--sticky-top-section z15 bg-white' },
                React.createElement("div", { className: 'h-4' }),
                React.createElement("div", { className: 'width-100 flex-container align-center' },
                    React.createElement("div", { className: 'width-100', style: { maxWidth: 450 } },
                        React.createElement(progress_to_shipping_threshold_bar_1.default, __assign({}, freeShippingProgressBarProps)))),
                React.createElement("div", { className: 'h-4' }),
                React.createElement("div", { className: 'border-very-light-pink', style: { borderTopWidth: 1, borderTopStyle: 'solid' } }))),
            renderFilters(),
            React.createElement("div", { className: 'grid-x grid-margin-x grid-margin-y' }, sortedDiscountAddOns.map(function (_a) {
                var _b = __read(_a, 2), product = _b[0], variant = _b[1];
                return (React.createElement("div", { className: 'cell small-6 medium-4', key: variant.id },
                    React.createElement(variant_quantity_picker_1.default, { priceLine: (0, format_price_1.default)(variant.price), compareAtPrice: variant.compare_at_price ? (0, format_price_1.default)(variant.compare_at_price) : undefined, product: product, variant: variant, setModalChoice: handleOpenModalClick({ product: product, variant: variant }), enableDetailsModal: settings.enableDetailsModal, numSelected: selDiscountAddOns.filter(function (_a) {
                            var id = _a.id;
                            return id === variant.id;
                        }).length, handleIncClick: handleIncreaseDiscountAddOnClick, handleDecClick: handleDecreaseDiscountAddOnClick })));
            }))),
        openModalProductVariant && (React.createElement(variant_details_modal_1.default, { productVariantArr: openModalProductVariant, handleCloseModalClick: handleCloseModalClick, isDiscount: true, handleIncreaseClick: handleIncreaseDiscountAddOnClick }))));
};
exports.default = SelectDiscountAddOns;
